import { useCallback } from "react";
import { 
    Box,
    Button,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from "@mui/material";
import { Campaign } from "../../../../types/campaign";
import { formatDateTime } from "../../../../hooks/formatNumber";

const rowsPerPage = 5;

type RowsType = {
    data: Campaign[];
    adStatus: string;
    page: number;
    showAlert: (a: string, b: string, c: number) => void;
    handleMediaChange: (a: string[], b: string) => void;
}

const Rows = ({ data, adStatus, page, showAlert, handleMediaChange }: RowsType) => {
    const emptyMessage = adStatus === "pendingApproval" ? "No campaigns awaiting approval" : "No active campaigns";
    const approveMessage = "Are you sure you want to approve this ad? Once active, it will automatically begin at the start time.";
    const rejectMessage = "Include a message describing why you are rejecting this ad.";

    const pageData = useCallback(() => {
        return data.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    }, [data, page]);

    return (
        <TableBody>
            {data.length === 0 ? (
                <TableRow key={0} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component="th" scope="row">
                        <Typography>{emptyMessage}</Typography>
                    </TableCell>
                </TableRow>
            ) : (
                pageData().map((row) =>
                    <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th">
                            <Typography>{row.nickname}</Typography>
                            <Typography variant="caption">{row.title}</Typography>
                        </TableCell>
                        <TableCell align="right">
                            <Typography>{formatDateTime(row.startTime)}</Typography>
                        </TableCell>
                        <TableCell align="right">
                            <Typography>{formatDateTime(row.endTime)}</Typography>
                        </TableCell>
                        <TableCell align="right">
                            <Button 
                                onClick={() => handleMediaChange(row.media.urls, row.title)}
                                disabled={row.media.urls.length === 0}
                                sx={{ padding: 0 }}
                            >
                                View Media
                            </Button>
                        </TableCell>
                        {adStatus === "pendingApproval" &&
                            <TableCell align="right">
                                 <Box display="flex" flexDirection="row" justifyContent="flex-end" gap={2}>
                                    <Button
                                        variant="contained"
                                        onClick={() => showAlert(approveMessage, "approve", row.id)}
                                    >
                                        Approve Ad
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => showAlert(rejectMessage, "reject", row.id)}
                                    >
                                        Reject Ad
                                    </Button>
                                </Box>
                            </TableCell>
                        }
                    </TableRow>
                )
            )}
        </TableBody>
    )
}

export default Rows;
